import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=7999be1d&scoped=true&"
var script = {}
import style0 from "./Navigation.vue?vue&type=style&index=0&id=7999be1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7999be1d",
  null
  
)

export default component.exports